import { UserPersonalData } from "../types";

export const defaultProfile: UserPersonalData = {
    user_id: 123,
    first_name: "Имя",
    last_name: "Фамилия",
    phone: "",
    whatsapp: "",
    telegram: "",
    city: "",
    birth_date: "",
    date_updated: "",
    employ_date: "",
    unemploy_date: "",
    address: ""
}